function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-circled-close",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "29-desktop-UI-circled-close",
  transform: "translate(-727.000000, -1030.000000)",
  strokeWidth: 2
}, React.createElement("g", {
  id: "Group-6-circled-close",
  transform: "translate(135.000000, 999.000000)"
}, React.createElement("g", {
  id: "modules/accordion_collapsed-circled-close"
}, React.createElement("g", {
  id: "icons/dark/65x65/close-circled-close",
  transform: "translate(588.000000, 27.000000)"
}, React.createElement("path", {
  d: "M15,25 C16.3839355,25 17.6822856,24.7361602 18.8950893,24.2084727 C20.107893,23.6807852 21.16443,22.9635868 22.0647321,22.0568562 C22.9650343,21.1501255 23.6793128,20.0910503 24.2075893,18.8795987 C24.7358657,17.668147 25,16.3712444 25,14.9888517 C25,13.6064591 24.7358657,12.3095564 24.2075893,11.0981048 C23.6793128,9.88665318 22.9650343,8.83129398 22.0647321,7.93199554 C21.16443,7.0326971 20.107893,6.31921483 18.8950893,5.79152731 C17.6822856,5.2638398 16.3839355,5 15,5 C13.6160645,5 12.3177144,5.2638398 11.1049107,5.79152731 C9.89210703,6.31921483 8.83556998,7.0326971 7.93526786,7.93199554 C7.03496574,8.83129398 6.32068717,9.88665318 5.79241071,11.0981048 C5.26413426,12.3095564 5,13.6064591 5,14.9888517 C5,16.3712444 5.26413426,17.668147 5.79241071,18.8795987 C6.32068717,20.0910503 7.03496574,21.1501255 7.93526786,22.0568562 C8.83556998,22.9635868 9.89210703,23.6807852 11.1049107,24.2084727 C12.3177144,24.7361602 13.6160645,25 15,25 Z",
  id: "Arrow-right-circle---simple-line-icons-circled-close",
  stroke: "#3F5063",
  transform: "translate(15.000000, 15.000000) rotate(45.000000) translate(-15.000000, -15.000000) "
}), React.createElement("g", {
  id: "Group-circled-close",
  transform: "translate(15.000000, 15.000000) rotate(45.000000) translate(-15.000000, -15.000000) translate(9.000000, 9.000000)",
  fillRule: "nonzero",
  stroke: "#6EC18A",
  strokeLinecap: "round"
}, React.createElement("path", {
  d: "M11,6 L1,6",
  id: "Line-4-circled-close"
}), React.createElement("path", {
  d: "M6.16911765,1 L6.16911765,11",
  id: "Line-4-Copy-circled-close"
})))))));

var SvgCircledClose = function SvgCircledClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircledClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circledClose.2e15e928.svg";
export { ForwardRef as ReactComponent };